import { render, staticRenderFns } from "./project-members-list.component.vue?vue&type=template&id=74fd328e&scoped=true&"
import script from "./project-members-list.component.vue?vue&type=script&lang=ts&"
export * from "./project-members-list.component.vue?vue&type=script&lang=ts&"
import style0 from "./project-members-list.component.vue?vue&type=style&index=0&id=74fd328e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fd328e",
  null
  
)

export default component.exports